/**
 * Вкладки раздела настроек.
 *
 * Список живёт отдельно от страницы, потому что нужен и маршрутизатору: он
 * должен отличать `/settings/events` от опечатки в адресе, а не показывать
 * пустую вкладку на любую строку после косой черты.
 */

export interface SettingsTabDefinition {
  slug: string;
  label: string;
}

export const SETTINGS_TABS = [
  { slug: 'general', label: 'Общие' },
  { slug: 'events', label: 'Наборы' },
  { slug: 'applications', label: 'Анкеты и заявки' },
  { slug: 'rollbacks', label: 'Откаты' },
  { slug: 'messages', label: 'Тексты в Discord' },
  { slug: 'dm', label: 'Личные сообщения' },
  { slug: 'wiring', label: 'Каналы и роли' },
] as const satisfies readonly SettingsTabDefinition[];

export type SettingsTab = (typeof SETTINGS_TABS)[number]['slug'];

/** Вкладка, которая открывается по короткому адресу `/settings`. */
export const DEFAULT_SETTINGS_TAB: SettingsTab = 'general';

export function isSettingsTab(value: string): value is SettingsTab {
  return SETTINGS_TABS.some((tab) => tab.slug === value);
}

/**
 * Адрес вкладки.
 *
 * У вкладки по умолчанию он короткий: `/settings` — то, куда ведёт боковое
 * меню и куда возвращается человек по прежним ссылкам. `/settings/general`
 * тоже открывается, но канонический адрес один.
 */
export function settingsTabPath(slug: SettingsTab): string {
  return slug === DEFAULT_SETTINGS_TAB ? '/settings' : `/settings/${slug}`;
}
